module.exports = __webpack_public_path__ + "img/card.8ddbde91.svg";